/** Shared `Dialog.Panel` classes for admin form modals (wrap content in `PopupWrapper`). */
export const MODAL_PANEL_CLASS =
	'w-full max-w-5xl min-h-0 max-h-[100dvh] overflow-hidden p-0 sm:mx-4 sm:my-4 sm:max-h-[min(92dvh,920px)] sm:rounded-app bg-[hsl(var(--card))] text-[hsl(var(--card-foreground))] border border-[hsl(var(--border))] shadow-2xl isolate'

export const MODAL_PANEL_CLASS_MD = `${MODAL_PANEL_CLASS} !max-w-3xl`

export const MODAL_PANEL_CLASS_SM = `${MODAL_PANEL_CLASS} !max-w-xl`

/** Confirm / alert dialogs (no inner `PopupWrapper` required). */
export const MODAL_CONFIRM_PANEL_CLASS =
	'w-full max-w-md min-h-0 overflow-hidden p-0 sm:mx-4 sm:my-8 sm:rounded-app shadow-2xl isolate'

/** Default flex placement for vertically centered modals on larger screens. */
export const MODAL_PLACEMENT_CENTER = 'justify-center items-center p-4 sm:p-6'

export const MODAL_PLACEMENT_TOP = 'justify-center items-start p-4 sm:pt-8'

/** Checkout modal — single surface; inner layout owns columns and background. */
export const MODAL_PANEL_CLASS_CHECKOUT =
	'flex w-full max-w-[920px] flex-col overflow-hidden p-0 sm:mx-4 sm:rounded-app border-0 bg-transparent shadow-none isolate max-h-[min(92dvh,760px)] min-h-[min(560px,88dvh)]'

/** Free-trial checkout — same chrome as paid checkout, without the tall empty min-height. */
export const MODAL_PANEL_CLASS_CHECKOUT_FREE =
	'flex w-full max-w-[920px] flex-col overflow-hidden p-0 sm:mx-4 sm:rounded-app border-0 bg-transparent shadow-none isolate max-h-[min(92dvh,640px)]'

export type ModalTransitionVariant = 'default' | 'slideLeftRight'

export const MODAL_TRANSITION_CLASSES: Record<
	ModalTransitionVariant,
	{ enter: string; enterFrom: string; enterTo: string; leave: string; leaveFrom: string; leaveTo: string }
> = {
	default: {
		enter: 'ease-out duration-300',
		enterFrom: 'opacity-0 translate-y-3 sm:translate-y-0 sm:scale-95',
		enterTo: 'opacity-100 translate-y-0 sm:scale-100',
		leave: 'ease-in duration-200',
		leaveFrom: 'opacity-100 translate-y-0 sm:scale-100',
		leaveTo: 'opacity-0 translate-y-2 sm:translate-y-0 sm:scale-95',
	},
	slideLeftRight: {
		enter: 'ease-out duration-400',
		enterFrom: 'opacity-0 -translate-x-10 sm:-translate-x-16',
		enterTo: 'opacity-100 translate-x-0',
		leave: 'ease-in duration-250',
		leaveFrom: 'opacity-100 translate-x-0',
		leaveTo: 'opacity-0 translate-x-8',
	},
}
